// @flow

import { initialState } from 'hfty-operator-accounts'

export default {
  ...initialState,
}
